import { createAsyncThunk } from '@reduxjs/toolkit';
import { IWebFormStyleClass } from '@qodly/shared';
import { getSharedCSS } from '@qodly/shared';
import { AppState } from '..';

export const fetchSharedCss = createAsyncThunk<
  IWebFormStyleClass[],
  void,
  {
    state: AppState;
    rejectValue: string;
  }
>(
  'shared_css/fetchSharedCSS',

  async (_, { rejectWithValue }) => {
    try {
      const { classes } = await getSharedCSS({ createIfNotExists: true });

      return classes;
    } catch (e) {
      return rejectWithValue('Error while loading the shared CSS');
    }
  },
);
